export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-feedback/es/index.js
// module id = 860
// module chunks = 0